import React from 'react'
import { CFView, DefaultScreen, MobileScreen } from 'components'
import { contactbg, mobileContactbg } from 'images'
import RestaurantDetails from './RestaurantDetails'
import Hours from './Hours'
import Map from './Map'
import SocialMedia from './SocialMedia'
import DownloadApp from './DownloadApp'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <Map />
          <CFView
            column
            center
            mt="-5px"
            w="100%"
            pt="50px"
            pb="150px"
            image={`url(${mobileContactbg}) bottom / cover no-repeat`}
          >
            <CFView w="100%" column center>
              <RestaurantDetails />
              <Hours />
              <SocialMedia />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center>
          <Map />
          <CFView
            w="100%"
            pv="50px"
            pr="100px"
            mt="-5px"
            row
            justifyEnd
            alignStart
            image={`url(${contactbg}) center / cover no-repeat`}
          >
            <CFView column mr="50px">
              <RestaurantDetails />
              <SocialMedia />
            </CFView>
            <Hours />
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
